import React from 'react'
import NavigateFromBase from './NavigateFromBase'

const NoRouteMatch = () => {
  return <NavigateFromBase to="" replace={true} />
}

export default NoRouteMatch
